import { Virus } from './components';
import {
	Multiplayer,
	PlayerConstants,
	ShopConstants,
	SimulationConstants,
	VirusSpawnerConstants,
} from './constants';
import { Debug } from './debug';
import { Game } from './game';
import { GameElement } from './gameElementTypes';

Debug.ManualSimulationStart = true;
Debug.MinimalCrap = false;
Debug.CaptureMode = false;
Debug.KeepTraceLogs = true;
Debug.ShowHitboxes = false;
Debug.ColorPaletteVialUrlAllowed = false;
Debug.KeepInspection = false;
Debug.SkipRecap = false;
Debug.SkipTutorial = false;
Debug.EnableAudioMixer = false;
Debug.ShowFPS = true;
Debug.UseDevReplays = false;
//Multiplayer.EarliestRewardRound = 0;
Debug.PlayAgainstLastReplay = false;
Debug.DontReportReplay = true;
Debug.SystemPerformanceTracking = true;
Debug.NoEAPopup = true;
Debug.NoAchievements = false;
//Debug.DeterministicSeed = 777; //spawns in back lane, all same direction
//Debug.DeterministicSeed = 8499;
Debug.UseLocalJoinUrl = false;

// if (Debug.MinimalCrap) {
// 	Multiplayer.NumberOfPlayers = 1
// 	Multiplayer.NumberOfBots = 0;
// 	// PlayerConstants.StartingFunds = 1000;
// 	// PlayerConstants.GameMaxFunds = 1000;
// Debug.ForcePlayerId = 2;
// }

//Multiplayer.NumberOfBots = 0;
//Debug.ForcePlayerId = 1;
// // SimulationConstants.MinRoundForReplaySave = 1;
// Debug.SaveReplayEveryTurn = true;

if (Debug.ManualSimulationStart) {
	// PlayerConstants.StartingFunds = 20;
	// PlayerConstants.MaxStartingMoney = 20;
	// //VirusSpawnerConstants.BattleRoundGrowthProgression = [0.5, 0.5, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2,];
	// //PlayerConstants.StartingHpByTrainingLevel = [2, 2, 2, 2];
	// Debug.ForceImmuneCell = [GameElement.CHAINER, GameElement.WALL, GameElement.PUSHER, GameElement.SEEKER, GameElement.SIMPLE];
	//Debug.ForceImmuneCell = [GameElement.SENTRY_ORBITER, GameElement.CHAINER, GameElement.WALL];
	// Debug.ForceVirusType = [GameElement.SPLITTER];
	// Debug.ForceLaneAngles = [90, 135, -90];
	// Debug.ForceLaneDistances = [70, 70, 0];
	// Debug.ForceWaveLanes = [0, 1, 2, 0, 1, 2, 0, 0, 0, 0];
	// VirusSpawnerConstants.NewVirusCountPerRound = [
	// 	8, 6, 8, 6, 8, 4, 1, 1, 1, 1, 1, 1,
	// ];
}

// PlayerConstants.StartingFunds = 50;
